import { TPpdTaskBase } from "../../../App/PpdBaseTask";
import { IRibbonFilterBox } from "../../../App/IRibbonFilterBox";
import { PpdStoredValues } from "../../../App/PpdStoredValues";
import { Dictionary } from "@ogaf/scripts/Modules/Collections";
import * as moment from "moment";
import TrateSelectionMap from "../../../Map/TrateSelectionMap";

export class SpoBaseTask extends TPpdTaskBase implements IRibbonFilterBox {

    /** Šířka popup okna (CSS hodnota). */
    public static readonly POP_UP_WIDTH: string = "80%";
    /** Výška popup okna (CSS hodnota). */
    public static readonly POP_UP_HEIGHT: string = "auto";
    /** ID bodů pro mapu v detailu. */
    private detailMapIds: { Points: number[] } = { Points: [] };
    /** Timer pro centrování mapy v detailu. */
    private detailMapCenteringTimer: number | NodeJS.Timeout | null = null;
    /** ID aktuálně zvýrazněných hran v detailní mapě. */
    private detailHighlightedEdgeIds: number[] = [];
    /** Příznak interní změny (potlačení handlerů při programové změně). */
    private isInternalChange: boolean = false;
    /** Typ souboru používaný při kontrolách dostupnosti (Xml/Pdf). */
    private readonly fileType: string | undefined;
    /** Naposledy načtené datum z dteDay – pro detekci skutečné změny data. */
    private lastLoadedDate: string = "";
    /** Počet souborů v aktuální dávce čekající na dokončení (úspěch nebo chyba). */
    private pendingUploads: number = 0;
    /** Příznak, zda byl v aktuálním popup sezení úspěšně nahrán alespoň jeden soubor. */
    private uploadedSuccessfully: boolean = false;

    /**
     * Konstruktor úlohy.
     * @returns void
     */
    constructor() {
        super();
        //nastaví disabled u filtrů a exportu při prvotním spuštění
        $(() => {
            this.updateRibbonControlsStateByDate();
            setTimeout(() => this.updateRibbonControlsStateByDate(), 0);
        });
    }

    /**
     * Zpracování akcí z ribbonu podle klíče.
     * @param key
     * @returns void
     */
    public override dispatchAction(key: string): void {
        switch (key) {
            case "fnClearFilter":
                void this.clearRibbonFilter();
                break;
            case "fnUploadTTP":
                this.showTTPTableUploadPopup();
                break;
            case "fnExport":
                this.exportAction();
                break;
            default:
                console.log(key);
                break;
        }
    }

    /**
    * Metoda nastaví hodnotu data v prvku filtru výběru dne při initu ze stored values
    */
    public setDteDayValue(): Date {
        // Datum se vzdy promaze
        this.userStoredRibbonFilterValues = new PpdStoredValues("Trate_filter", "1", this.repairStoredRibbonFilterValues, this);
        this.userStoredRibbonFilterValues.ReplaceCollection(this.repairStoredRibbonFilterValues(null, this.userStoredRibbonFilterValues.Version, this));
        return null;
    }

    /**
    * Metoda nastaví hodnotu hledaného stringu v prvku filtru vyhledávání při initu ze stored values
    */
    public setTxtSearch(): string {
        return this.userStoredRibbonFilterValues.Get("searchString");
    }

    /**
   * Nastaveni hodnoty pro prvky v Ribbon Filter Boxu
   */
    public loadRibbonFilterValue(storedContorlName: string, returnNumber: boolean = false): string | number {
        let value = this.userStoredRibbonFilterValues.Get(storedContorlName);
        if (returnNumber)
            return value === "" ? "" : Number(value);
        else
            return value;
    }

    /**
     * Metoda si vyžádá potvrzení od uživatele a až pak načte view.
     * Pokud se datum skutečně změnilo, volá DB. Pokud je stejné, jen zobrazí TracksViewModel.
     * Při jakékoli změně data vymaže filtr cmbValidFrom.
     */
    public dteDay_valueChange(e: DevExpress.ui.dxDateBox.ValueChangedEvent): void {
        if (this.isInternalChange) {
            this.isInternalChange = false;
            this.updateRibbonControlsStateByDate();
            return;
        }

        const newDate = e.value;
        const formattedDate = newDate ? this.formatDate(newDate) : "";

        DevExpress.ui.dialog.confirm(
            `Chcete opravdu nastavit datum ${formattedDate}?`,
            "Potvrzení"
        ).done((dialogResult) => {
            if (dialogResult) {
                const newFormattedDate = e.value === null ? "" : this.formatDate(e.value);

                if (newFormattedDate === this.lastLoadedDate) {
                    // Stejné datum, jen zobrazíme TracksViewModel bez DB dotazu
                    this.changeViewByRibbonFilter(false);
                } else {
                    // Datum se skutečně změnilo → DB dotaz
                    this.lastLoadedDate = newFormattedDate;
                    this.changeViewByRibbonFilter(true);
                }
            } else {
                // uživatel zrušil změnu, vrátíme původní datum
                this.isInternalChange = true;
                e.component.option("value", e.previousValue);
            }
        });
    }

    /**
    * Aktualizuje stav ovládacích prvků v ribbonu podle toho, zda je vybráno datum.
    * Povoluje nebo zakazuje filtry, vyhledávání a exportní tlačítka. Při neexistenci data
    * deaktivuje také generování PDF a XML pro celou síť.
    */
    private updateRibbonControlsStateByDate(): void {
        const hasDate = !!this.getInputDateFromWidget();
        const trackRegionFilter = $("#trackRegionFilter").dxButtonGroup("instance");
        const cmbValidFrom = $("#cmbValidFrom").dxSelectBox("instance");
        const txtSearch = $("#txtSearch").dxTextBox("instance");

        trackRegionFilter?.option("disabled", !hasDate);
        cmbValidFrom?.option("disabled", !hasDate);
        txtSearch?.option("disabled", !hasDate);

        const btnExport = document.querySelector<HTMLButtonElement>("button[data-function-key='fnExport']");
        if (btnExport) {
            btnExport.disabled = !hasDate;
        }

        if (!hasDate) {
            const btnPdf = document.getElementById("btnWholeNetPdf") as HTMLButtonElement | null;
            const btnXml = document.getElementById("btnWholeNetXml") as HTMLButtonElement | null;
            if (btnPdf) {
                btnPdf.disabled = true;
                btnPdf.onclick = null;
            }
            if (btnXml) {
                btnXml.disabled = true;
                btnXml.onclick = null;
            }
        }
    }

    /**
     * Reakce na změnu regionu ve filtru.
     * Filtruje existující TracksViewModel na serveru — žádný DB dotaz.
     */
    public trackRegionFilter_changed(e: DevExpress.ui.dxButtonGroup.SelectionChangedEvent): void {
        const region = (e.addedItems?.[0])?.region ?? "";
        this.userStoredRibbonFilterValues.Set("trackRegion", region);
        this.changeViewByRibbonFilter(false);
    }

    /**
      * Klik na šipku nahoru/dolů — posune dteDay o jeden den.
      */
    public btnDay_click(e: DevExpress.ui.dxButton.ClickEvent): void {
        const dteDay = $("#dteDay").dxDateBox("instance");
        const currentDate = dteDay.option("value") ? new Date(dteDay.option("value")) : new Date();
        const newDate = new Date(currentDate);
        const minDate = new Date(2025, 7, 1); // 2025-08-01

        const id = $(e.element).attr("id");
        if (id === "btnDayUp") {
            newDate.setDate(newDate.getDate() + 1);
        } else if (id === "btnDayDown") {
            newDate.setDate(newDate.getDate() - 1);
            if (newDate < minDate) return;
        } else {
            return;
        }

        // Nastaví datum s potvrzovacím dialogem
        dteDay.option("value", newDate);
    }

    /**
      * Změna textu vyhledávání — filtruje existující TracksViewModel na serveru.
      * Debounce 500 ms zabraňuje volání při každém stisku klávesy.
      */
    public txtSearch_valueChange(e: DevExpress.ui.dxTextBox.ValueChangedEvent): void {
        this.debounce(() => {
            this.userStoredRibbonFilterValues.Set("searchString", e.value?.toString().trim() ?? "");
            this.changeViewByRibbonFilter(false);
        }, 500);
    }

    /** Timer pro debouncing textového vyhledávání. */
    private debounceTimer: ReturnType<typeof setTimeout> | null = null;

    /**
     * metoda pro debouncing volání fcí
     * @param func
     * @param delay
     */
    private debounce(func: () => void, delay: number): void {
        if (this.debounceTimer !== null) clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
            this.debounceTimer = null;
            func();
        }, delay);
    }

    /**
     * JSON metoda na převod data do stringu v požadovaném formátu dd.mm.yyyy
     * @param date
     * @returns string s požadovaným formátem data
     */
    private formatDate(date: Date): string {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();

        return `${day}.${month}.${year}`;
    }

    /**
    * Kolekce uzivatelskych vyberu filtru v ribbonu
    */
    public userStoredRibbonFilterValues: PpdStoredValues = new PpdStoredValues("Trate_filter", "1", this.repairStoredRibbonFilterValues, this);

    /**
    * JSON fetchModelu vraceneho v body do controlleru
    * @returns string
    */
    public fetchRibbonFilterBody(): string {

        const inputDate = this.getInputDateFromWidget();
        const searchString = this.userStoredRibbonFilterValues.Get("searchString");
        const trackRegion = this.userStoredRibbonFilterValues.Get("trackRegion");
        const validFrom = this.userStoredRibbonFilterValues.Get("cmbValidFrom");
        return JSON.stringify({
            inputDate: inputDate,
            searchString: searchString,
            trackRegion: trackRegion,
            fileType: this.fileType ?? 'Unknown fileType',
            validFrom: validFrom
        });
    }

    /**
     * Hlavní metoda, která vrací záznamy na základě změny ve filtru.
     * refreshDataSet=true  → volá DB (GetTrateData) a transformuje nová rawData
     * refreshDataSet=false → filtruje existující data na serveru (GetFilteredTracksData)
     */
    public async changeViewByRibbonFilter(refreshDataSet: boolean = true): Promise<void> {
        this.App.showLoadingPanel(false);

        // Zapamatovat fokus txtSearch před přepsáním DOM
        const searchHasFocus = document.activeElement === $("#txtSearch").dxTextBox("instance")?.element()?.get(0)?.querySelector("input");

        try {
            const action = refreshDataSet ? "GetTrateData" : "GetFilteredTrateData";
            const res = await this.dispatchToServer(action, {
                data: JSON.parse(this.fetchRibbonFilterBody())
            });

            if (!res.ok) {
                console.error(`${action} returned HTTP ${res.status}!`);
                return;
            }

            if (res.status === 200) {
                const html = await res.text();
                const container = document.getElementById("trackListView");
                if (container) {
                    container.innerHTML = html;
                    this.updateSpoAvailabilityInfoVisibility();
                    this.updateWholeNetButtons();
                    this.updateCmbValidFrom();
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.App.hideLoadingPanel();
            // Vrátit fokus a kurzor na konec textu
            if (searchHasFocus) {
                const input = $("#txtSearch").dxTextBox("instance")?.element()?.get(0)?.querySelector("input");
                if (input) {
                    input.focus();
                    const len = input.value.length;
                    input.setSelectionRange(len, len);
                }
            }
            this.updateRibbonControlsStateByDate();
        }
    }

    /**
     * Zobrazí informaci o počtu dostupných SPO pouze tehdy,
     * když je ve filtru Platnost vybrané validní datum.
     */
    private updateSpoAvailabilityInfoVisibility(): void {
        const info = document.getElementById("spoAvailabilityInfo");
        if (!info)
            return;

        info.style.display = this.getInputDateFromWidget() ? "" : "none";
    }

    /**
     * Zakáže všechna tlačítka pro stahování, pokud není vybrané datum platnosti.
     * Tlačítka Detail zůstávají dostupná.
     */
    private disableDownloadButtons(): void {
        document.querySelectorAll<HTMLButtonElement>(
            ".btn-track:not(.btn-track-detail), #btnWholeNetPdf, #btnWholeNetXml"
        ).forEach(button => {
            button.disabled = true;
        });
    }

    /**
     * Přečte z vyrenderovaného partial view dostupnost souborů celé sítě
     * a podle toho povolí / zakáže tlačítka btnWholeNetPdf a btnWholeNetXml.
     */
    private updateWholeNetButtons(): void {
        const el = document.getElementById("wholeNetAvailability");

        const isPdfAvailable = el?.dataset.pdfAvailable === "true";
        const xmlFileId = el?.dataset.xmlFileId;

        const btnPdf = document.getElementById("btnWholeNetPdf") as HTMLButtonElement | null;
        const btnXml = document.getElementById("btnWholeNetXml") as HTMLButtonElement | null;

        if (btnPdf) {
            btnPdf.disabled = !isPdfAvailable;
            btnPdf.onclick = isPdfAvailable
                ? () => { this.downloadFiles("pdf", undefined, "wholenet"); }
                : null;
        }

        if (btnXml) {
            btnXml.disabled = !xmlFileId;
            btnXml.onclick = xmlFileId
                ? () => { this.downloadFiles("xml", "CelaSit", undefined, undefined, Number(xmlFileId)); }
                : null;
        }
    }

    /**
     * Přečte z vyrenderovaného partial view seznam platností TTP
     * a aktualizuje DataSource prvku cmbValidFrom v ribbonu.
     */
    private updateCmbValidFrom(): void {
        const el = document.getElementById("ttpValidFromData");
        if (!el) return;

        const raw = el.dataset.values;
        if (!raw) return;

        const values: string[] = JSON.parse(raw);
        const dataSource = values.map(v => ({ Text: v, Value: v }));

        const cmb = $("#cmbValidFrom").dxSelectBox("instance");
        if (!cmb) return;

        cmb.option("dataSource", dataSource);
    }

    /**
     * Metoda zobrazí upozornění o nastaveném datu a po odkliknutí Ok
     * nastaví dteDay na dnešní den a načte data.
     */
    public initUserAwareness(): void {
        const dateTodayFormatted = this.formatDate(new Date());

        this.App.showMessageBoxEx(
            "Upozornění",
            `Datum je nastaveno na dnešní den, tj. ${dateTodayFormatted}. Pro změnu vyberte požadované datum ve filtru.`,
            "CurrentTask",
            "setTodayDateAfterAwareness",
            "Ok1"
        );
    }

    /**
     * Callback volaný po odkliknutí Ok v initUserAwareness message boxu.
     * Nastaví dteDay na dnešní den a načte data.
     */
    public async setTodayDateAfterAwareness(): Promise<void> {
        const initialDate = this.getInitialDateValue();

        const dteDay = $("#dteDay").dxDateBox("instance");
        if (!dteDay)
            return;

        this.isInternalChange = true;
        dteDay.option("value", initialDate);

        this.updateRibbonControlsStateByDate();
        await this.changeViewByRibbonFilter();
        await this.afterInitialDataLoaded();
    }

    /**
     * Vrátí datum použité při prvním načtení úlohy.
     */
    protected getInitialDateValue(): Date {
        return new Date();
    }

    /**
     * Hook volaný po prvním načtení dat úlohy.
     */
    protected afterInitialDataLoaded(): Promise<void> {
        return Promise.resolve();
    }

    /**
     * Metoda kontroluje zda hodnoty v oldValues odpovidaji aktualne pripustnym hodnotam prvku, pokud ne, pak je nahradi na vychozi hodnoty
     * @param oldValues Slovnik hodnot puvodne ulozenych v localStorage, nebo null (pro vytvoreni slovniku vychozich hodnot)
     * @param version Aktuální verze hodnot
     * @param task Aktuální úloha které náleží kolekce
     * @returns Slovnik opravenych, nebo vychozich hodnot z predaneho oldValues
     */
    public repairStoredRibbonFilterValues(oldValues: Dictionary<string>, version: string, task: SpoBaseTask): Dictionary<string> {
        let dicVal: Dictionary<string> = new Dictionary();
        dicVal.Add("filterVersion", version);

        if (oldValues !== null && oldValues.Keys.length > 0) {
            dicVal.Add("validFrom", oldValues.ContainsKey("validFrom") ? oldValues["validFrom"] : "");
            dicVal.Add("searchString", oldValues.ContainsKey("searchString") ? oldValues["searchString"] : "");
            dicVal.Add("trackRegion", oldValues.ContainsKey("trackRegion") ? oldValues["trackRegion"] : "")
        } else {
            dicVal.Add("validFrom", "");
            dicVal.Add("searchString", "");
            dicVal.Add("trackRegion", "")
        }

        return dicVal
    }

    /**
     * Vymaže všechny hodnoty filtrů včetně data platnosti
     * a obnoví úlohu do výchozího stavu.
     */
    public async clearRibbonFilter(): Promise<void> {
        // 1. Vynulovat localStorage
        this.userStoredRibbonFilterValues.ReplaceCollection(
            this.repairStoredRibbonFilterValues(null, this.userStoredRibbonFilterValues.Version, this)
        );

        // 2. Vynulovat widgety — bez spouštění jejich handlerů
        let eventHandler: (e: DevExpress.events.NativeEventInfo<any>) => void;

        const trackRegionFilter = $("#trackRegionFilter").dxButtonGroup("instance");
        eventHandler = trackRegionFilter.option("onSelectionChanged");
        trackRegionFilter.option("onSelectionChanged", null);
        trackRegionFilter.option("selectedItemKeys", [""]);
        trackRegionFilter.option("onSelectionChanged", eventHandler);

        const txtSearch = $("#txtSearch").dxTextBox("instance");
        eventHandler = txtSearch.option("onValueChanged");
        txtSearch.option("onValueChanged", null);
        txtSearch.option("value", "");
        txtSearch.option("onValueChanged", eventHandler);

        const cmbValidFrom = $("#cmbValidFrom").dxSelectBox("instance");
        if (cmbValidFrom) {
            eventHandler = cmbValidFrom.option("onValueChanged");
            cmbValidFrom.option("onValueChanged", null);
            cmbValidFrom.option("value", "");
            cmbValidFrom.option("onValueChanged", eventHandler);
        }

        const dteDay = $("#dteDay").dxDateBox("instance");
        eventHandler = dteDay.option("onValueChanged");
        dteDay.option("onValueChanged", null);
        dteDay.option("value", "");
        dteDay.option("onValueChanged", eventHandler);

        // 3. Resetovat interní stav posledního načteného data.
        this.lastLoadedDate = "";

        // 4. Zrušit filtry i nad aktuálně načteným datasetem.
        // GetFilteredTrateData při prázdných filtrech vrátí celý TracksViewModel
        // bez nového DB dotazu.
        await this.changeViewByRibbonFilter(false);

        // 5. Platnost zůstává prázdná, proto souhrn SPO skryjeme
        // a download tlačítka ponecháme zakázaná.
        this.updateSpoAvailabilityInfoVisibility();
        this.updateRibbonControlsStateByDate();
        this.disableDownloadButtons();
    }

    /**
     * Stáhne soubor(y) podle kontextu:
     * - fileId vyplněno              → jeden soubor (trať) přes DownloadFile
     * - scope "group" / "region"     → ZIP skupiny/regionu přes DownloadFiles
     * - scope "wholenet" + type "xml"→ jeden XML soubor celé sítě přes DownloadFile (fileId z DOM)
     * - scope "wholenet" + type "pdf"→ ZIP celé sítě přes DownloadFiles
     */
    public async downloadFiles(

        type: string,
        track?: string,
        scope?: "group" | "region" | "wholenet",
        id?: number,
        fileId?: number
    ): Promise<void> {
        this.App.showLoadingPanel(false);

        try {
            const inputDate = this.getInputDateFromWidget();
            let action: string;
            let payload: object;

            if (fileId) {
                // Jeden soubor — trať nebo XML celé sítě
                action = "DownloadFile";
                payload = { fileId, track, type, inputDate };
            } else if (scope === "wholenet" || (scope && id !== undefined)) {
                // ZIP skupiny / regionu / celé sítě
                action = "DownloadFiles";
                payload = { id: id ?? 0, scope, type, inputDate };
            } else {
                console.error("downloadFiles: chybí fileId nebo scope");
                return;
            }

            const res = await this.dispatchToServer(action, payload);

            if (!res.ok) { console.error(`${action} returned HTTP ${res.status}!`); return; }

            const blob = await res.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            const match = /filename\*?=(?:UTF-8''|"?)([^;"]+)/i
                .exec(res.headers.get("Content-Disposition") ?? "");
            if (match?.[1]) a.download = decodeURIComponent(match[1]);
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);

        } catch (error) {
            this.App.showMessageBoxEx("Zpráva o stažení", "Nastala neočekávaná chyba.", "", "", "Ok");
            console.error(error);
        } finally {
            this.App.hideLoadingPanel();
        }
    }

    /**
     * Získá hodnotu data z widgetu dxDateBox.
     * @returns
     */
    private getInputDateFromWidget(): string {
        const rawValue = $("#dteDay").dxDateBox("instance")?.option("value");
        if (!rawValue) return "";
        const d = new Date(rawValue);
        if (Number.isNaN(d.getTime())) return "";
        return `${d.getDate().toString().padStart(2, '0')}.${(d.getMonth() + 1).toString().padStart(2, '0')}.${d.getFullYear()}`;
    }

    // ─── Upload TTP tabulek ────────────────────────────────────────────────────
    /**
     * Otevře popup pro upload TTP tabulek.
     * @returns
     */
    public async showTTPTableUploadPopup(): Promise<void> {
        this.App.showLoadingPanel(false);
        try {
            const res = await this.dispatchToServer("ShowTTPTableUploadPopup");
            if (!res.ok) { console.error(`ShowTTPTableUploadPopup returned HTTP ${res.status}!`); return; }

            const data = await res.json().catch(() => null);
            if (data != null) {
                this.SetAndShowPopupSimple(
                    "ttpTableUpload-popup",
                    data,
                    "Nahrát tabulky TTP",
                    "1250", "500",
                    () => {
                        $("#TTPTableFileUploader").dxFileUploader("instance")?.reset();
                        if (this.uploadedSuccessfully) {
                            this.uploadedSuccessfully = false;
                            this.changeViewByRibbonFilter(true);
                        }
                    },
                    null
                );
            }
        } catch (e) {
            console.error(e);
        } finally {
            this.App.hideLoadingPanel();
        }
    }

    /**
     * Zavolá se při zahájení uploadu celé dávky (klik na "Uložit soubory").
     * Inicializuje čítadlo pro agregaci výsledků.
     */
    public TTPTableFileUploader_onUploadStarted(e: DevExpress.ui.dxFileUploader.UploadStartedEvent): void {
        if (this.pendingUploads === 0) {
            // První soubor v dávce — inicializujeme stav
            this.failedUploads = [];
        }
        this.pendingUploads++;
    }

    /**
     * Zavolá se těsně před odesláním každého jednotlivého XHR.
     * Přidá aktuální validFrom jako query parametr — bezpečné pro libovolný počet souborů
     * (na rozdíl od nastavení uploadUrl v onValueChanged, které podléhá race condition).
     */
    public TTPTableFileUploader_onBeforeSend(e: DevExpress.ui.dxFileUploader.BeforeSendEvent): void {
        const validFrom = $("#dteTTPTableValidFrom").dxDateBox("instance")?.option("value");
        if (!validFrom) {
            e.request.abort();
            this.App.showMessageBoxEx("Upozornění", "Vyberte datum platnosti.", "", "", "Ok");
            return;
        }
        const iso = new Date(validFrom).toISOString();
        e.request.open("POST", `FileUpload?validFrom=${encodeURIComponent(iso)}`, true);
    }

    /**
     * Reaguje na úspěšný upload jednoho souboru.
     */
    public TTPTableFileUploader_onUploaded(e: DevExpress.ui.dxFileUploader.UploadedEvent): void {
        this.pendingUploads--;
        this.tryShowUploadResult();
    }

    /**
     * Reaguje na chybu uploadu jednoho souboru.
     * Chyby agreguje — zobrazí se najednou po dokončení celé dávky.
     */
    public TTPTableFileUploader_onUploadError(e: DevExpress.ui.dxFileUploader.UploadErrorEvent): void {
        const failedFile = e.file?.name ?? "neznámý soubor";
        const status = e.request?.status;
        const responseText = e.request?.responseText?.trim() ?? "";

        const errMsg = status === 400
            ? responseText === "InvalidFileNameFormat"
                ? `Neplatný název souboru: ${failedFile}`
                : responseText === "UnknownTrack"
                    ? `Neznámá trať pro soubor: "${failedFile}"`
                    : `Chyba souboru "${failedFile}": ${responseText}`
            : `Chyba při nahrávání souboru "${failedFile}" (HTTP ${status}).`;

        this.failedUploads.push(errMsg);
        this.pendingUploads--;
        this.tryShowUploadResult();
    }

    /**
     * zobrazuje výsledek nahrávání po dokončení celé dávky (úspěch / selhání).
     * @returns
     */
    private tryShowUploadResult(): void {
        if (this.pendingUploads > 0) return;

        const totalFiles = $("#TTPTableFileUploader").dxFileUploader("instance")?.option("value")?.length ?? 0;
        const failedCount = this.failedUploads.length;
        const successCount = totalFiles - failedCount;

        if (failedCount > 0) {
            const list = this.failedUploads.map(m => `<li>${m}</li>`).join("");
            this.App.showMessageBoxEx(
                "Výsledek nahrávání",
                `<b>${successCount}</b> souborů nahráno, <b>${failedCount}</b> selhalo:`
                + `<ul style="list-style:none;padding-left:0">${list}</ul>`,
                "", "", "Ok"
            );
        } else {
            this.App.showMessageBoxEx(
                "Výsledek nahrávání",
                "Všechny soubory byly úspěšně nahrány.",
                "", "", "Ok"
            );
        }

        if (successCount > 0) {
            this.uploadedSuccessfully = true;
            // Plný refresh tratí proběhne po zavření popupu přes onHidden.
            $("#TTPTableFileUploader").dxFileUploader("instance")?.reset();
        }

        this.failedUploads = [];
        this.pendingUploads = 0;
    }

    /**
     * Validace datumu platnosti — nelze vybrat datum v minulosti.
     */
    public dteZacatekPlatnosti_valueChanged(e: DevExpress.ui.dxDateBox.ValueChangedEvent): void {
        if (e.value === null || !e.component.option("isValid")) {
            e.component.option("value", e.previousValue);
            return;
        }
        const selected = new Date(e.value);
        selected.setHours(0, 0, 0, 0);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (selected < today) {
            this.App.showMessageBoxEx("Upozornění", "Datum nesmí být dřív než dnešní den.", "", "", "Ok");
            e.component.option("value", e.previousValue);
        }
    }

    /**
     * Zobrazí popup s přímým HTML obsahem.
     */
    public SetAndShowPopupSimple(
        popupId: string, content: string, title: string = "",
        width: string = "auto", height: string = "auto",
        onHidden: (e: DevExpress.ui.dxPopup.HiddenEvent) => void = null,
        onShown: (e: DevExpress.ui.dxPopup.ShownEvent) => void = null,
        hideOnOutsideClick: boolean = false,
        maxWidth: string = "95vw", maxHeight: string = "80vh",
        dragEnabled: boolean = false
    ): void {
        const popup = $("#" + popupId).dxPopup("instance");
        popup.option("title", title);
        popup.option("width", width);
        popup.option("height", height);
        popup.option("maxWidth", maxWidth);
        popup.option("maxHeight", maxHeight);
        popup.option("dragEnabled", dragEnabled);
        popup.option("hideOnOutsideClick", hideOnOutsideClick);
        popup.option("onHidden", onHidden);
        popup.option("onShown", onShown);
        popup.content().html(content);
        if (popup) popup.hide();
        popup.show();
    }

    /**
     * Hlavni metoda, ktera vraci zaznamy na zaklade zmeny ve filtru
     * @param track String trate
     * @returns Promise<void>
     */
    public async showDetailPopup(track: string = ""): Promise<void> {
        if (!track) return;

        this.App.showLoadingPanel(false);

        try {
            const inputDate = this.getInputDateFromWidget();
            const res = await this.dispatchToServer("ShowDetailPopup", { track, inputDate });

            if (!res.ok) {
                console.error(`ShowDetailPopup returned HTTP ${res.status}!`);
                return;
            }

            const data = await res.json();

            if (data?.DetailTemplate) {
                const mapIds = data.MapIds || {};
                this.detailMapIds = {
                    Points: Array.isArray(mapIds.Points) ? mapIds.Points : []
                };
                // ← Reset stale instance — nové HTML = nový DX widget
                (CurrentTask as any).TrateDetailGridInstance = null;

                const handleMapShown = async () => {
                    await this.reinitializeDetailMap();
                };

                this.SetAndShowPopupSimple(
                    "trateDetail-popup",
                    data.DetailTemplate,
                    `Detail tratě ${track}`,
                    SpoBaseTask.POP_UP_WIDTH,
                    SpoBaseTask.POP_UP_HEIGHT,
                    null,
                    () => { void handleMapShown(); },
                    false,
                    "95vw",
                    "90vh"
                );
            }
        } catch (e) {
            console.error(e);
        } finally {
            this.App.hideLoadingPanel();
        }
    }

    /**
      * Znovu inicializuje mapu v popupu — zahodí starou instanci a zavolá initMap().
      */
    private async reinitializeDetailMap(): Promise<void> {
        const mapDiv = document.getElementById("mapDiv");
        let overlay: HTMLDivElement | null = null;
        if (mapDiv) {
            overlay = document.createElement("div");
            overlay.style.cssText =
                "position:absolute;inset:0;display:flex;align-items:center;" +
                "justify-content:center;background:rgba(255,255,255,0.8);z-index:9999;border-radius:4px;";
            // Čistý CSS spinner — žádná závislost na DX inicializaci
            overlay.innerHTML = `
                <div style="
                    width:36px;height:36px;
                    border:4px solid #ddd;
                    border-top-color:#337ab7;
                    border-radius:50%;
                    animation:og-spin 0.8s linear infinite;">
                </div>`;
            // Přidat @keyframes pokud ještě není
            if (!document.getElementById("og-spin-style")) {
                const style = document.createElement("style");
                style.id = "og-spin-style";
                style.textContent = "@keyframes og-spin { to { transform: rotate(360deg); } }";
                document.head.appendChild(style);
            }
            mapDiv.style.position = "relative";
            mapDiv.appendChild(overlay);
        }

        try {
            if (typeof globalThis.initMap === "function") {
                await new Promise(resolve => setTimeout(resolve, 0));
                const currentMap = (globalThis as any).OGMap as TrateSelectionMap | null;
                if (currentMap) {
                    const mapAny = currentMap as any;
                    if (typeof mapAny.Dispose === "function") mapAny.Dispose();
                    else if (typeof mapAny.Destroy === "function") mapAny.Destroy();
                }
                (globalThis as any).OGMap = null;
                globalThis.initMap();
            }
        } catch (mapInitError) {
            console.error(mapInitError);
        } finally {
            this.detailMapCenteringTimer = setTimeout(() => {
                this.showMap();
                overlay?.remove();
            }, 1500);
        }
    }

    /**
      * Označí vybrané body a hrany v OGMap a přiblíží na ně.
      */
    private showMap(): void {
        const points = this.detailMapIds.Points || [];
        const map = globalThis.OGMap as TrateSelectionMap;

        if (typeof map.SetPointSelected === "function") {
            for (const id of points) {
                map.SetPointSelected(id);
            }
        }

        if (typeof map.GetPointsArrFromIdsArr === "function" &&
            typeof map.CenterMapOnArea === "function") {
            const pointsArr = map.GetPointsArrFromIdsArr(points);
            if (pointsArr?.length > 0) {
                map.CenterMapOnArea(pointsArr, "Points");
            }
        }

        if (map) {
            this.highlightEdgesBetweenPoints(points, map);
        }

        this.detailMapCenteringTimer = null;
    }


    /**
 * Ověří, zda jsou předány validní vstupy pro zvýraznění hran.
 */
    private canHighlightEdges(ids: number[], map: TrateSelectionMap): boolean {
        return !!map
            && Array.isArray(ids)
            && ids.length >= 2
            && typeof map.GetShortestRoute === "function";
    }

    /**
     * Vrátí sanitizovaná (číselná) ID bodů, nebo null pokud jich není dost.
     */
    private getSanitizedPointIds(ids: number[]): number[] | null {
        const sanitized = ids.filter((id): id is number => typeof id === "number");
        return sanitized.length >= 2 ? sanitized : null;
    }

    /**
     * Uloží aktuální relevantní stav mapy před modifikací.
     */
    private saveMapHighlightState(map: TrateSelectionMap): { layer: string; coherence: string; selectedPoints: number[] } {
        return {
            layer: map.ActiveLayer,
            coherence: map.Coherence,
            selectedPoints: Array.isArray(map.SelectedPoints) ? [...map.SelectedPoints] : [] as number[]
        };
    }

    /**
     * Přepočítá nejkratší trasy mezi sousedními body a zvýrazní je na mapě.
     */
    private computeShortestRoutes(ids: number[], map: TrateSelectionMap): void {
        map.ActiveLayer = "Edges";
        map.Coherence = "Coherent";
        map.ClearEdgesSelections?.();
        map.ClearPointsSelections?.();

        for (let i = 1; i < ids.length; i++) {
            const from = ids[i - 1];
            const to = ids[i];
            if (from === to) continue;
            if (typeof map.GetPointWithId === "function"
                && (!map.GetPointWithId(from) || !map.GetPointWithId(to))) continue;
            map.GetShortestRoute(from, to);
        }

        this.detailHighlightedEdgeIds = Array.isArray(map.SelectedEdges)
            ? [...map.SelectedEdges] : [];
    }

    /**
     * Obnoví stav mapy po zvýraznění a znovu označí vybrané body.
     */
    private restoreMapHighlightState(
        map: TrateSelectionMap,
        state: ReturnType<typeof this.saveMapHighlightState>,
        fallbackIds: number[]
    ): void {
        map.ActiveLayer = state.layer;
        map.Coherence = state.coherence;
        map.ClearPointsSelections?.();

        const pointsToRestore = state.selectedPoints.length > 0 ? state.selectedPoints : fallbackIds;
        const unique = [...new Set(pointsToRestore.filter(p => typeof p === "number"))];

        for (const pid of unique) {
            if (typeof map.GetPointWithId === "function" && !map.GetPointWithId(pid)) continue;
            map.SetPointSelected(pid);
        }
    }

    /**
     * Zvýrazní hrany mezi vybranými body pomocí GetShortestRoute.
     */
    private highlightEdgesBetweenPoints(ids: number[], map: TrateSelectionMap): void {
        this.detailHighlightedEdgeIds = [];

        if (!this.canHighlightEdges(ids, map)) return;

        const sanitizedIds = this.getSanitizedPointIds(ids);
        if (!sanitizedIds) return;

        const state = this.saveMapHighlightState(map);
        try {
            this.computeShortestRoutes(sanitizedIds, map);
        } catch (error) {
            console.error("Chyba při zvýraznění hran:", error);
        } finally {
            this.restoreMapHighlightState(map, state, sanitizedIds);
        }
    }

    /**
     * Reakce na změnu výběru v cmbValidFrom.
     * Vybraná hodnota → aplikuje filtr TTP (GetFilteredTracksData).
     * Vymazaná hodnota → zobrazí původní TracksViewModel (GetFilteredTracksData s prázdným validFrom).
     */
    public validFrom_valueChange(e: DevExpress.ui.dxSelectBox.ValueChangedEvent): void {
        if (this.isInternalChange) return;

        this.userStoredRibbonFilterValues.Set("cmbValidFrom", e.value ?? "");
        this.changeViewByRibbonFilter(false);
    }

    /**
    * Metoda, vyvolaná po kliknutí na export
    * @returns Promise<void>
    */
    public async exportAction(): Promise<void> {
        this.App.showLoadingPanel(false);

        try {
            const res = await this.dispatchToServer("ExcelDownload", {
                data: JSON.parse(this.fetchRibbonFilterBody())
            });

            if (!res.ok) {
                console.error(`ExcelDownload returned HTTP ${res.status}!`);
                return;
            }

            const blob = await res.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;

            const inputDate = res.headers.get("X-Input-Date");
            const exportDate = inputDate
                ? moment(inputDate, "DD.MM.YYYY")
                : moment();

            a.download = `TratěTTP_${exportDate.format("YYYYMMDD")}.xlsx`;

            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error(error);
        } finally {
            this.App.hideLoadingPanel();
        }
    }

}